import { useSelector } from "react-redux";
import { authSelector } from "../reducers";
import { LoginView } from "../unauthenticated";
import { Navigate } from "react-router";

/**
 * Home - Guards routes that require authentication
 * Shows LoginView component if not authenticated
 */
export const Home = () => {
  const auth = useSelector(authSelector);

  // Not authenticated or MFA required - show login
  if (!auth || auth.mfaRequired) {
    return <LoginView />;
  }

  // Authenticated - render child routes
  return <Navigate to="/dashboard" replace />;
};